import { render, staticRenderFns } from "./CommercialAdmins.vue?vue&type=template&id=1d403d29"
import script from "./CommercialAdmins.vue?vue&type=script&lang=js"
export * from "./CommercialAdmins.vue?vue&type=script&lang=js"
import style0 from "./CommercialAdmins.vue?vue&type=style&index=0&id=1d403d29&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports